import { render, staticRenderFns } from "./AcuerdoPreguntas.vue?vue&type=template&id=076eb6b5&"
import script from "./AcuerdoPreguntas.vue?vue&type=script&lang=js&"
export * from "./AcuerdoPreguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports